/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './NamedResourceTag';
import { ReleaseStatusFromJSON, ReleaseStatusToJSON, } from './ReleaseStatus';
/**
 * Check if a given object implements the ContentResponse interface.
 */
export function instanceOfContentResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function ContentResponseFromJSON(json) {
    return ContentResponseFromJSONTyped(json, false);
}
export function ContentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'active': json['active'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'releaseStatus': !exists(json, 'releaseStatus') ? undefined : ReleaseStatusFromJSON(json['releaseStatus']),
        'releaseMessage': !exists(json, 'releaseMessage') ? undefined : json['releaseMessage']
    };
}
export function ContentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'metaData': MetaDataToJSON(value.metaData),
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'organisationId': value.organisationId,
        'userId': value.userId,
        'active': value.active,
        'name': value.name,
        'url': value.url,
        'releaseStatus': ReleaseStatusToJSON(value.releaseStatus),
        'releaseMessage': value.releaseMessage
    };
}
